// import React from 'react';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import LoginScreen from './components/LoginScreen/LoginScreen';
// import AdminDashboard from './components/Admin/Dashboard';

// // 🔒 Route Guard: Checks authorization before rendering the Admin Shell
// const ProtectedRoute = ({ children }) => {
//   const isAuthenticated = sessionStorage.getItem('isLoggedIn');
//   const userSession = sessionStorage.getItem('userSession');

//   if (!isAuthenticated || !userSession) {
//     // If no active session validation is found, kick them back to the login gateway
//     return <Navigate to="/login" replace />;
//   }

//   return children;
// };

// function App() {
//   return (
//     <Router>
//       <Routes>
//         {/* Route 1: Root redirect to login */}
//         <Route path="/" element={<Navigate to="/login" replace />} />

//         {/* Route 2: Public Login Portal */}
//         <Route path="/login" element={<LoginScreen />} />

//         {/* Route 3: Secure Protected Admin Workspace */}
//         <Route 
//           path="/dashboard" 
//           element={
//             <ProtectedRoute>
//               <AdminDashboard />
//             </ProtectedRoute>
//           } 
//           style={{ margin: 0, padding: 0 }}
//         />

//         {/* Fallback Route: Catch-all unmapped paths and send to login */}
//         <Route path="*" element={<Navigate to="/login" replace />} />
//       </Routes>
//     </Router>
//   );
// }

// export default App;


import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginScreen from './components/LoginScreen/LoginScreen';
import AdminDashboard from './components/Admin/Dashboard';
import HomePage from './components/LandingPage/HomePage'; // ➕ IMPORT: Your new landing website component
import AboutPage from './components/LandingPage/AboutPage';
import AdmissionsPage from './components/LandingPage/AdmissionsPage';
import ProspectusPage from './components/LandingPage/ProspectusPage';
import FeeStructurePage from './components/LandingPage/FeeStructurePage';
import ProgramsPage from './components/LandingPage/ProgramsPage';
import StudyCentresPage from './components/LandingPage/StudyCentresPage';
import AnnouncementsPage from './components/LandingPage/AnnouncementsPage';
import DownloadsPage from './components/LandingPage/DownloadsPage';
import StudentLogin from './components/LandingPage/StudentLogin';
import EnquiryPage from './components/LandingPage/EnquiryPage';
import ContactEnquiryPage from './components/LandingPage/ContactEnquiryPage';
import BooksPage from './components/LandingPage/BooksPage';
import ExamsPage from './components/LandingPage/ExamsPage';
import LiveClassesPage from './components/LandingPage/LiveClassesPage';

// 🔒 Route Guard: Checks authorization before rendering the Admin Shell
const ProtectedRoute = ({ children }) => {
  const isAuthenticated = sessionStorage.getItem('isLoggedIn');
  const userSession = sessionStorage.getItem('userSession');

  if (!isAuthenticated || !userSession) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

function App() {
  return (
    <Router>
      
      <Routes>
        {/* Route 1: Root path now serves the public Landing Page directly */}
        <Route path="/" element={<HomePage />} />
<Route path="/about" element={<AboutPage />} />
 <Route path="/admissions" element={<AdmissionsPage />} />
 <Route path="/prospectus" element={<ProspectusPage />} />
 <Route path="/fee-structure" element={<FeeStructurePage />} />
 <Route path="/programs" element={<ProgramsPage />} />
 <Route path="/study-centres" element={<StudyCentresPage />} />
 <Route path="/announcements" element={<AnnouncementsPage />} />
 <Route path="/downloads" element={<DownloadsPage />} />
 <Route path="/student-login" element={<StudentLogin />} />
  <Route path="/enquiry" element={<EnquiryPage />} />
  <Route path="/books" element={<BooksPage />} />
    <Route path="/exams" element={<ExamsPage />} />
    <Route path="/contact-enquiry" element={<ContactEnquiryPage />} />
  <Route path="/live-classes" element={<LiveClassesPage />} />
        {/* Route 2: Public Login Portal */}
        <Route path="/login" element={<LoginScreen />} />

        {/* Route 3: Secure Protected Admin Workspace */}
        <Route 
          path="/dashboard" 
          element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } 
        />

        {/* Fallback Route: Catch-all unmapped paths send them to the public website or login */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Router>
  );
}

export default App;